"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var Modal_1 = require("../Modal");
var TetherComponent_1 = require("../Internal/TetherComponent");
var InfoIcon_1 = require("../Icons/InfoIcon");
var patchIcon_1 = require("../../utils/patchIcon");
var button_1 = require("./subcomponents/button");
var tooltip_1 = require("./subcomponents/tooltip");
var propTypes = {
    icon: PropTypes.func,
    children: PropTypes.node.isRequired,
    isModal: PropTypes.bool,
    variant: PropTypes.oneOf(['transparent']),
    isOpen: PropTypes.bool,
    onToggleOpen: PropTypes.func
};
var UnmanagedTooltipIconWithinContext = /** @class */ (function (_super) {
    __extends(UnmanagedTooltipIconWithinContext, _super);
    function UnmanagedTooltipIconWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.tooltip = null;
        _this.helperText = 'Mehr Informationen anzeigen';
        _this.handleOutsideTooltipClick = function (event) {
            if (_this.props.isOpen) {
                _this.props.onToggleOpen(event);
            }
        };
        _this.tooltipId = props.ergoElements.idGenerator.next();
        return _this;
    }
    UnmanagedTooltipIconWithinContext.prototype.setAsCurrentlyOpen = function () {
        // notify open instance
        if (UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon) {
            UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon.props.onToggleOpen();
        }
        // set this instance as currently open
        UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon = this;
    };
    UnmanagedTooltipIconWithinContext.prototype.unsetAsCurrentlyOpen = function () {
        if (UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon === this) {
            // unset this instance as currently open
            UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon = null;
        }
    };
    UnmanagedTooltipIconWithinContext.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this.setAsCurrentlyOpen();
        }
    };
    UnmanagedTooltipIconWithinContext.prototype.componentWillUnmount = function () {
        this.unsetAsCurrentlyOpen();
    };
    UnmanagedTooltipIconWithinContext.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                this.setAsCurrentlyOpen();
                if (!this.props.isModal) {
                    this.tether.update();
                }
            }
            else {
                this.unsetAsCurrentlyOpen();
            }
        }
    };
    UnmanagedTooltipIconWithinContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, isModal = _a.isModal, icon = _a.icon, isOpen = _a.isOpen;
        var theme = this.props.ergoElements.theme;
        var componentClassName = classNames(className, 'ee_tooltip-icon');
        var cssButtonClassNames = classNames('ee_tooltip-icon__button', this.props.variant
            ? "ee_tooltip-icon__button--" + this.props.variant
            : undefined);
        var tooltipWrapperClassName = classNames('ee_tooltip__wrapper', {
            'ee_is-open': isOpen
        });
        var patchedTooltipIcon = patchIcon_1.default(icon, {
            title: this.helperText
        });
        var tooltipIconButton = (React.createElement(button_1.default, { onClick: this.props.onToggleOpen, open: isOpen, tooltipId: this.tooltipId, icon: patchedTooltipIcon, buttonClassName: cssButtonClassNames, title: this.helperText }));
        if (isModal) {
            return (React.createElement("span", { className: componentClassName },
                tooltipIconButton,
                React.createElement(Modal_1.default, { id: this.tooltipId, open: isOpen, dismissible: true, onDismiss: this.props.onToggleOpen, backdropDismissesModal: true }, children)));
        }
        else {
            return (React.createElement(TetherComponent_1.TetherComponent, { attachment: "top left", targetAttachment: "bottom left", ref: function (instance) {
                    _this.tether = instance;
                }, classPrefix: "ee_tooltip-root", targetOffset: theme === 'ergo-one' ? '0 -12px' : '18px -9px', constraints: [
                    {
                        to: 'window',
                        pin: true,
                        attachment: 'together'
                    }
                ], theme: theme },
                React.createElement("span", { className: componentClassName }, tooltipIconButton),
                React.createElement(tooltip_1.default, { className: tooltipWrapperClassName, tooltipId: this.tooltipId, reference: function (el) {
                        _this.tooltip = el;
                    }, toggleTooltip: this.props.onToggleOpen, onClickOutsideTooltip: this.handleOutsideTooltipClick }, children)));
        }
    };
    UnmanagedTooltipIconWithinContext.propTypes = propTypes;
    UnmanagedTooltipIconWithinContext.defaultProps = {
        isModal: false,
        icon: InfoIcon_1.default,
        onToggleTooltip: undefined,
        variant: undefined,
        onToggleOpen: function () {
            /* intentionally empty */
        },
        isOpen: false
    };
    UnmanagedTooltipIconWithinContext.currentlyOpenInfoIcon = null;
    return UnmanagedTooltipIconWithinContext;
}(react_1.Component));
exports.UnmanagedTooltipIconWithinContext = UnmanagedTooltipIconWithinContext;
//# sourceMappingURL=UnmanagedTooltipIconWithinContext.js.map
